import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import './assets/fonts/iconfont.css'
import axios from 'axios'
import TreeTable from 'vue-table-with-tree-grid'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'

//axios.defaults.baseURL = 'http://localhost:5000/api_v1'
//axios.defaults.baseURL = 'http://39.107.221.117:5000/api_v1'
// axios.defaults.baseURL = 'http://111.42.74.202:5000/api_v1'
// axios.defaults.baseURL = 'http://114.116.228.167/api_v1'

// 请求头拦截
axios.interceptors.request.use(config => {
        NProgress.start()
        config.headers.Authorization = window.sessionStorage.getItem('token')
        return config
    })
    // 响应拦截
axios.interceptors.response.use(config => {
    NProgress.done()
    if (config.data.status === 101) {
        Message({
            message: config.data.data,
            type: 'error'
        });
    }
    if (config.data.status === 102) {
        window.sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("username")
        router.push("/login")
    }
    if (config.data.status === 105) {
        router.push("/welcome");
        Message({ message: config.data.data, type: 'error' });
    }
    return config
}, err => {
    NProgress.done();
    Message({
        message: "请求错误",
        type: 'error'
    });
    return Promise.reject(err);
})
Vue.prototype.$http = axios


Vue.component('tree-table', TreeTable)
Vue.use(VueQuillEditor)

Vue.filter('dateFormat', (originVal) => {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
        // const ss = (dt.getSeconds() + 1 + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}`
})

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')